import React from 'react';
import { Component } from 'react';
import { Link } from 'react-router-dom';
export default class TuneMenu extends Component {

  render() {
    return (
      <div className="flex-container-full">
        <div><Link to={"/tune/adventure/"}>Adventure</Link></div>
        <div><Link to={"/tune/single/note"}>Single Note</Link></div>
        <div><Link to={"/tune/multi/intervals"}>Intervals</Link></div>
        <div><Link to={"/tune/multi/triads"}>Triads</Link></div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/tune-menu.js